// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","773":"08f0de60","3165":"1f8bc7fb","4509":"c8def894","5787":"7b3978e1"}[chunkId] + ".chunk.css";
};